import { defineStore } from "pinia";

const devModuleList = ["module_globus"];
const prodModuleList = ["module_globus"];

// const isProd = window.location.port.length === 0 || window.location.port === "8888";
const isProd = !window.location.host.includes("dev.");

export const useStore = defineStore({
    id: "store",
    state: () => ({
        isTelegramAuthorized: false, // Флаг авторизации в ТГ боте для уведомлений.
        isProd: !window.location.hostname.includes("dev."),
        loader: false,
        isInitialized: false, // Флаг завершения personalAreaInitialize
        notifications: [],
        showType: "login", // login close open
        activeModule: { name: "Глобус", dataName: "module_globus"},
        routing: [],
        mainHrefApp: "",
        showMode: localStorage.getItem("lk_tab") || "projects",
        language: {code: "ru"},
        isShowLogoutDialog: false, // Диалог входа/выхода
        isShowProjectNoModuleDialog: false // Диалог, если в активном проекте нет текущего модуля
    }),
    actions: {
        getEnabledModuleList() {
          return isProd ? prodModuleList : devModuleList;
        },
        toggleLogoutDialog(value) {
            this.isShowLogoutDialog = value;
        },
        createNotify(mess, type) {
            this.notifications.push({
                message: mess,
                type: type,
                color: type === "success" ? "green" : "red",
                lifeTime: type === "success" ? 5000 : 5000
            });
        },
    }
});
